import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TooltipConfig, TooltipModule } from 'ngx-bootstrap/tooltip';
import { FeatureFlagModule } from 'ngx-feature-flag';
import { ModalService } from '../../services/modal.service';
import { DeleteWorkItemComponent } from './delete-work-item.component';



export class DeleteWorkItemModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    TooltipModule,
    FeatureFlagModule
  ],
  declarations: [
    DeleteWorkItemComponent
  ],
  exports: [
    DeleteWorkItemComponent
  ],
  providers: [
    ModalService,
    TooltipConfig
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
